import React, { useState, useEffect } from "react";
import "./Collections.css";
import ArchiveItem from "../../components/ArchiveItem/ArchiveItem";
import NoData from "../../components/NoData/NoData";

const Collections = () => {
  const [archives, setArchives] = useState([]);
    const [loading, setLoading] = useState(false); // Loader state
  

  const getArchives = async () => {
    try {
      const response = await fetch(
        "https://admin.riymay.com/api/v1/admin/get/archieves"
      );
      const result = await response.json();
      if (response.ok) {
        setArchives(result.data); 
      }
    } catch (error) {
      console.error("Error fetching archives:", error.message);
    }
  };

  useEffect(() => {
    getArchives();
  }, []);

  
  return (
    <div className="archive-container">
      <div className="content">
        {archives.imageAudioArchives ? (
          archives.imageAudioArchives.map((item) => (
            <ArchiveItem key={item._id} item={item} type="audio" />
          ))
        ) : (
          <NoData />
        )}

        {archives.videoArchives ? (
          archives.videoArchives.map((video) => (
            <ArchiveItem key={video._id} item={video} type="video" />
          ))
        ) : (
          <p>Loading video archives...</p>
        )}
      </div>
    </div>
  );
};

export default Collections;